
<div tabindex="0">
  <transition name="fade">
    <Loader v-if="loading" full-screen />
    <router-view v-else />
  </transition>
</div>
